<template>
  <div>
    <!-- 筛选查询 -->
    <div class="wScreenArea">
      <el-card class="box-card">
        <div slot="header" class="wScreenCardHeader">
          <span>拼团订单查询</span>
          <div class="wScreenCardHeader-right">
            <div class="wSCHR-title">
              总计<span style="color: #ff6321">{{ wTable.wTotal }}</span>个拼团
            </div>
          </div>
        </div>
        <el-form ref="wScreenForm" label-position="left" label-width="90px" :model="wScreen" @submit.native.prevent>
          <el-row :gutter="20">
            <!-- 拼团状态 -->
            <el-col :span="6">
              <el-form-item label="拼团状态" prop="state">
                <el-select v-model="wScreen.state" placeholder="全部状态" clearable @change="wFun_queryTableData(true)">
                  <el-option v-for="item in groupState" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 拼团类型 -->
            <el-col :span="6">
              <el-form-item label="拼团类型" prop="type">
                <el-select v-model="wScreen.type" placeholder="全部类型" clearable @change="wFun_queryTableData(true)">
                  <el-option v-for="item in groupType" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- 拼团编号 -->
            <el-col :span="6">
              <el-form-item label="拼团编号" prop="id">
                <el-input 
                  style="width: 100%" 
                  v-model="wScreen.id" 
                  placeholder="请输入拼团编号" 
                  clearable
                  @keyup.enter.native="wFun_queryTableData(true)">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 发起人ID -->
            <el-col :span="6">
              <el-form-item label="发起人ID" prop="organizerId">
                <el-input 
                  style="width: 100%" 
                  v-model="wScreen.organizerId" 
                  placeholder="请输入发起人ID"
                  clearable
                  @keyup.enter.native="wFun_queryTableData(true)">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 操作按钮 -->
            <el-col :span="12" style="text-align: right; padding-top: 5px;">
              <el-button size="medium" @click="wFun_formScreenReset">
                重置
              </el-button>
              <el-button type="primary" size="medium" @click="wFun_queryTableData(true)">
                查询
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <!-- 表格数据 -->
    <div class="wTableArea">
      <el-table 
        border 
        :data="wTable.wList" 
        v-loading="tableLoading"
        style="width: 100%">
        
        <!-- 展开行显示用户列表 -->
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="user-list-container">
              <h4>参与成员 ({{ props.row.userList.length }}/{{ props.row.type+1 }})</h4>
              <el-table :data="props.row.userList" border>
                <el-table-column prop="nickName" label="用户名" width="120" align="center"></el-table-column>
                <el-table-column label="用户信息" align="center">
                  <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                      <el-avatar size="small" :src="getAvatarUrl(scope.row.avatar)">
                        {{ scope.row.avatar || '用户' }}
                      </el-avatar>
                      <span style="margin-left: 10px;">{{ scope.row.phone }}</span>
                      <!-- 新增地址信息显示 -->
                      <span style="margin-left: 10px;">
                        <el-tag v-if="scope.row.orderAddress" type="success" size="mini">快递</el-tag>
                        <el-tag v-else type="info" size="mini">自提</el-tag>
                      </span>
                    </div>
                    <!-- 显示详细地址 -->
                    <div v-if="scope.row.orderAddress" style="text-align: left; margin-top: 5px; font-size: 12px; color: #666;">
                      {{ scope.row.orderAddress.areaCode }} {{ scope.row.orderAddress.address }}
                      <span v-if="scope.row.orderAddress.name">({{ scope.row.orderAddress.name }})</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="joinTime" label="参与时间" width="180" align="center"></el-table-column>
                <el-table-column label="身份" width="120" align="center">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.userId === props.row.organizerId" type="danger" size="small">团长</el-tag>
                    <el-tag v-else type="info" size="small">团员</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>

        <!-- 拼团编号 -->
        <el-table-column prop="id" label="拼团编号" width="180" align="center"></el-table-column>

        <!-- 拼团类型 -->
        <el-table-column label="拼团类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 5 ? '' : 'success'">
              {{ scope.row.type === 5 ? '五人团' : '十人团' }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 商品信息 -->
        <el-table-column label="商品信息" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.goodInfo" style="display: flex; align-items: center;">
              <el-image 
                style="width: 50px; height: 50px; margin-right: 10px;"
                :src="getFirstImage(scope.row.goodInfo.headImg)" 
                fit="cover"
                :preview-src-list="getImageList(scope.row.goodInfo.headImg)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div style="text-align: left;">
                <div>{{ scope.row.goodInfo.name }}</div>
                <div style="color: #999; font-size: 12px;">ID: {{ scope.row.goodInfo.id }}</div>
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <!-- 拼团价格 -->
        <el-table-column label="拼团价格" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #ff6321; font-weight: bold;">¥{{ scope.row.activityPrice }}</span>
          </template>
        </el-table-column>

        <!-- 当前人数 -->
        <el-table-column label="当前人数" width="120" align="center">
          <template slot-scope="scope">
            <el-progress 
              :percentage="Math.round((scope.row.userList.length / getGroupMaxMembers(scope.row)) * 100)" 
              color="#e6a23c"
              :show-text="false"
              style="width: 80%; margin: 0 auto;">
            </el-progress>
            <div style="margin-top: 5px;">
              {{ scope.row.userList.length }}/{{ getGroupMaxMembers(scope.row) }}
            </div>
          </template>
        </el-table-column>

        <!-- 拼团状态 -->
        <el-table-column label="拼团状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getGroupState(scope.row).type" effect="dark">
              {{ getGroupState(scope.row).text }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <!-- <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewGoodDetail(scope.row.goodInfo)">
              商品详情
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <div class="wPagination">
        <el-pagination 
          background 
          :layout="wC_layout" 
          :current-page="wTable.wPage" 
          :page-size="wTable.wLimit"
          :total="wTable.wTotal" 
          :page-sizes="wC_pageSizes" 
          @current-change="wELPageCurrentChange" 
          @size-change="wELPageSizeChange">
        </el-pagination>
      </div>
    </div>

    <!-- 商品详情弹窗 -->
    <el-dialog 
      :title="currentGood ? currentGood.name : '商品详情'"
      :visible.sync="goodDetailVisible" 
      width="60%"
      :close-on-click-modal="false">
      
      <div v-if="currentGood" class="good-detail-content">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-image 
              style="width: 100%; max-height: 300px;"
              :src="getFirstImage(currentGood.headImg)" 
              fit="contain"
              :preview-src-list="getImageList(currentGood.headImg)">
            </el-image>
            <div style="margin-top: 20px;">
              <el-tag type="success">商品ID: {{ currentGood.id }}</el-tag>
              <el-tag style="margin-left: 5px;">规格: {{ currentGood.unit }}</el-tag>
              <div style="margin-top: 10px;">
                <span style="font-size: 18px; color: #ff6321; font-weight: bold;">
                  ¥{{ currentGood.retailPrice }}
                </span>
              </div>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="good-desc" v-html="currentGood.details"></div>
          </el-col>
        </el-row>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="goodDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLegUpList } from "@/network/api.js";

export default {
  name: "GroupOrderList",
  data() {
    return {
      tableLoading: false,
      goodDetailVisible: false,
      currentGood: null,
      
      // 拼团状态
      groupState: [
        { id: 1, name: "等待助力" },
        { id: 3, name: "拼团成功" },
        
      ],
      
      // 拼团类型
      groupType: [
        { id: 5, name: "五人团" },
        { id: 10, name: "十人团" }
      ],
      
      // 筛选查询（只保留四个参数）
      wScreen: {
        state: null,  // 拼团状态
        type: null,   // 拼团类型
        organizerId: null, // 发起人ID
        id: null      // 拼团编号
      },
      
      // 表格数据
      wTable: {
        wPage: 1,
        wLimit: 10,
        wTotal: 0,
        wList: []
      }
    };
  },
  computed: {
    wC_layout() {
      return "total, sizes, prev, pager, next, jumper";
    },
    wC_pageSizes() {
      return [10, 20, 50, 100];
    }
  },
  created() {
    this.wFun_queryTableData(true);
  },
  methods: {
    // 获取图片列表
    getImageList(imgStr) {
      if (!imgStr) return [];
      try {
        const cleanStr = imgStr.replace(/[\[\]]/g, '');
        return cleanStr.split(', ').map(item => item.trim());
      } catch (e) {
        console.error('解析图片字符串出错:', e);
        return [];
      }
    },
    
    // 获取第一张图片
    getFirstImage(imgStr) {
      const images = this.getImageList(imgStr);
      return images.length > 0 ? images[0] : '';
    },
    
    // 获取用户头像URL
    getAvatarUrl(avatar) {
      return avatar || '';
    },
    getGroupMaxMembers(row) {
      if (row.type === 10) return 10;
      if (row.type === 5) return 6;
      return row.type || 0;
    },
    getGroupState(row) {
      if (row.state === -1) {
        return { text: '团长未支付', type: 'info' };
      }
      
      if (row.state === 3) {
        return { text: '拼团成功', type: 'success' };
      }
      if (row.userList.length === this.getGroupMaxMembers(row)) {
        return { text: '拼团成功', type: 'success' };
      }
      // 对于状态为1（等待助力）的情况，检查时间
      if (row.state === 1 && row.startTime) {
        const startTime = new Date(row.startTime.replace(/-/g, '/'));
        const now = new Date();
        const diffHours = (now - startTime) / (1000 * 60 * 60);
        
        if (diffHours > 24) { // 超过48小时（2天）
          return { text: '拼团结束', type: 'danger' };
        }
      }
      
      // 默认情况
      return { text: '等待助力', type: 'warning' };
    },
    // 获取拼团状态标签类型
    getStateTagType(state) {
      switch(state) {
        case -1: return 'info';
        case 1: return 'warning';
        case 2: return 'success';
        case 3: return 'danger';
        default: return '';
      }
    },
    
    // 获取进度条颜色
    getProgressColor(state) {
      switch(state) {
        case -1: return '#909399';
        case 1: return '#e6a23c';
        case 2: return '#67c23a';
        case 3: return '#f56c6c';
        default: return '#409eff';
      }
    },
    
    // 获取拼团状态文本
    getStateTagType(state) {
      const status = this.getGroupState({ state, startTime: '' });
      return status.type;
    },
    getStateText(state, startTime) {
      const status = this.getGroupState({ state, startTime });
      return status.text;
    },
    
    // 查看商品详情
    viewGoodDetail(goodInfo) {
      this.currentGood = goodInfo;
      this.goodDetailVisible = true;
    },
    
    // 查询表格数据（简化参数）
    async wFun_queryTableData(resetPage = false) {
      if (resetPage) {
        this.wTable.wPage = 1;
      }
      
      this.tableLoading = true;
      
      try {
        // 只传递四个参数
        const params = {
          pageModel: {
            pageNo: this.wTable.wPage,
            pageSize: this.wTable.wLimit,
            sortField: "createTime",
            sortWay: "desc"
          },
          state: this.wScreen.state,
          type: this.wScreen.type,
          organizerId: this.wScreen.organizerId,
          id: this.wScreen.id
        };
        
        const res = await getLegUpList(params);
        
        if (res) {
          this.wTable.wTotal = res.total;
          this.wTable.wList = res.records.map(item => {
            // 确保userList存在
            item.userList = item.userList || [];
            return item;
          });
        } else {
          this.$message.error(res.msg || '获取数据失败');
        }
      } catch (error) {
        console.error("获取拼团列表失败:", error);
        this.$message.error("获取拼团列表失败");
      } finally {
        this.tableLoading = false;
      }
    },
    
    // 重置表单
    wFun_formScreenReset() {
      this.wScreen = {
        state: null,
        type: null,
        organizerId: null,
        id: null
      };
      this.wFun_queryTableData(true);
    },
    
    // 分页变化
    wELPageCurrentChange(page) {
      this.wTable.wPage = page;
      this.wFun_queryTableData();
    },
    
    // 每页条数变化
    wELPageSizeChange(size) {
      this.wTable.wLimit = size;
      this.wFun_queryTableData(true);
    }
  }
};
</script>

<style scoped>
.wScreenCardHeader-right {
  display: flex;
  align-items: center;
}

.wScreenCardHeader-right .wSCHR-title {
  flex: none;
  padding-right: 20px;
  box-sizing: border-box;
  color: #333333;
}

.user-list-container {
  padding: 15px;
}

.good-detail-content {
  padding: 0 15px;
}

.good-desc {
  max-height: 400px;
  overflow-y: auto;
  line-height: 1.6;
}

.good-desc >>> ul {
  padding-left: 20px;
}

.good-desc >>> li {
  margin-bottom: 8px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

.wPagination {
  margin-top: 20px;
  text-align: right;
}
</style>
